<h1 mat-dialog-title>Registrar asistencia</h1>
<form [formGroup]="form" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <p>
      Ingresá el código que te brindó el profesor para dar el presente en la
      clase.
    </p>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Código</mat-label>
      <input
        #codeInput
        matInput
        formControlName="code"
        autocomplete="off"
        cdkFocusInitial
        placeholder="Ingresá el código"
      />
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="center">
    <button mat-button mat-dialog-close type="button" [disabled]="isSubmitting">
      Cancelar
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="form.invalid || isSubmitting"
    >
      <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
      <span *ngIf="!isSubmitting">Enviar</span>
    </button>
  </div>
</form>
